import { render, staticRenderFns } from "./UserPasswordBlock.vue?vue&type=template&id=2d9533b6&"
import script from "./UserPasswordBlock.vue?vue&type=script&lang=js&"
export * from "./UserPasswordBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports